import { render, staticRenderFns } from "./MessageFormTab.vue?vue&type=template&id=084e1957&scoped=true&lang=pug"
import script from "./MessageFormTab.vue?vue&type=script&lang=ts"
export * from "./MessageFormTab.vue?vue&type=script&lang=ts"
import style0 from "./MessageFormTab.vue?vue&type=style&index=0&id=084e1957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e1957",
  null
  
)

export default component.exports